/* Vulkanus: orthographic globe. Natural Earth public-domain country geometry.
   Dealer coordinates/names copied from this preview's existing page.haendler.json. */
(function () {
  if (window.__v3Globe) return;
  window.__v3Globe = true;
  const DEALERS = [
  {
    "name": "Vulkanus Headquarter",
    "country": "Österreich",
    "city": "Hallein",
    "address": "Egglstr. 3, 5400 Hallein",
    "url": "https://www.vulkanus.com",
    "category": "Hauptsitz",
    "lat": "47.68",
    "lng": "13.10"
  },
  {
    "name": "Gourmet-Leasing Franz Stolz",
    "country": "Österreich",
    "city": "Lans",
    "address": "Sistranser Straße 151, 6072 Lans",
    "url": "https://gourmet-leasing.at",
    "category": "Distributor",
    "lat": "47.24",
    "lng": "11.42"
  },
  {
    "name": "Josef Mäser GmbH",
    "country": "Österreich",
    "city": "Dornbirn",
    "address": "Rossmähder 9, 6850 Dornbirn",
    "url": "https://www.maeser.at",
    "category": "Fachhändler",
    "lat": "47.41",
    "lng": "9.74"
  },
  {
    "name": "Heinr. Böker Baumwerk GmbH",
    "country": "Deutschland",
    "city": "Solingen",
    "address": "Schützenstraße 30, 42659 Solingen",
    "url": "https://www.boker.de",
    "category": "Distributor",
    "lat": "51.17",
    "lng": "7.08"
  },
  {
    "name": "ARCOS HERMANOS S.A.",
    "country": "Spanien",
    "city": "Albacete",
    "address": "Avda. Gregorio Arcos 38, 02007 Albacete",
    "url": "https://www.arcos.com",
    "category": "Distributor",
    "lat": "38.99",
    "lng": "-1.86"
  },
  {
    "name": "Vikingsun AB",
    "country": "Schweden",
    "city": "Stockholm",
    "address": "Kungsholms Strand 125, 112 33 Stockholm",
    "url": "https://www.vikingsun.se",
    "category": "Distributor",
    "lat": "59.33",
    "lng": "18.06"
  },
  {
    "name": "Mastermark Brands Oy",
    "country": "Finnland",
    "city": "Turku",
    "address": "Vajossuonkato 16, 20380 Turku",
    "url": "https://www.mastermarkbrands.fi",
    "category": "Distributor",
    "lat": "60.45",
    "lng": "22.27"
  },
  {
    "name": "Aasgaard as",
    "country": "Norwegen",
    "city": "Årnes",
    "address": "Smiuvegen 13, 2150 Årnes",
    "url": "https://www.aasgaard.no",
    "category": "Distributor",
    "lat": "60.13",
    "lng": "11.47"
  },
  {
    "name": "Home Brands",
    "country": "Norwegen",
    "city": "Bryne",
    "address": "Industrivegen 1, 4344 Bryne",
    "url": "https://www.homebrands.no",
    "category": "Distributor",
    "lat": "58.73",
    "lng": "5.65"
  },
  {
    "name": "Maison Truffe AG",
    "country": "Schweiz",
    "city": "Stäfa",
    "address": "Laubisrütistrasse 52, 8712 Stäfa",
    "url": "https://www.maisontruffe.ch",
    "category": "Distributor",
    "lat": "47.24",
    "lng": "8.73"
  },
  {
    "name": "H.W. Larsen",
    "country": "Dänemark",
    "city": "Brøndby",
    "address": "Vallensbaekvej 25, 2605 Brøndby",
    "url": "https://www.hwl.dk",
    "category": "Distributor",
    "lat": "55.65",
    "lng": "12.42"
  },
  {
    "name": "Berkshire Innovations, Inc.",
    "country": "USA",
    "city": "Williamstown, MA",
    "address": "PO Box 712, Williamstown, MA 01267",
    "url": "https://brodandtaylor.com",
    "category": "Distributor",
    "lat": "42.71",
    "lng": "-73.20"
  },
  {
    "name": "Waltons and Company Group Ltd",
    "country": "Großbritannien",
    "city": "Bradford",
    "address": "1 Merrydale Road, Euroway Trading Estate, BD4 6SD Bradford",
    "url": "https://www.waltonsandcompany.com",
    "category": "Distributor",
    "lat": "53.79",
    "lng": "-1.75"
  },
  {
    "name": "LORENZI 1948 Coltelleria",
    "country": "Italien",
    "city": "Bozen",
    "address": "Via Bottai 28, 39100 Bozen",
    "url": "",
    "category": "Fachhändler",
    "lat": "46.50",
    "lng": "11.35"
  }
];
  let engine;
  function library(url) {
    if (window.VulkanusGeo) return Promise.resolve(window.VulkanusGeo);
    if (!engine) engine = new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.src = url;
      script.onload = () => resolve(window.VulkanusGeo); script.onerror = reject;
      document.head.append(script);
    });
    return engine;
  }
  function setup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const lang = root.dataset.locale;
    const empty = lang === 'en' ? 'Our partners: Europe & USA' : lang === 'es' ? 'Distribuidores: Europa y EE. UU.' : 'Unser Händlernetz: Europa & USA';
    const name = root.querySelector('[data-globe-name]'), place = root.querySelector('[data-globe-place]');
    const panel = root.querySelector('.v3-globe__partner');
    let geo, world, project, path, grid, active = false, ready = false, loading = false;
    let lon = -73.2, lat = 35, toLon = lon, toLat = lat, frame = 0, selected = -2;
    let width = 0, height = 0, radius = 0, drag = null, explicit = null, lastTop = null;
    function updatePartner(index, announce) {
      if (index === selected) return;
      selected = index; root.dataset.partner = String(index);
      if (index < 0) { name.textContent = empty; place.textContent = ''; }
      else {
        const d = DEALERS[index]; name.textContent = d.name;
        place.textContent = d.city + ' · ' + d.country;
      }
      panel.classList.remove('is-changing'); void panel.offsetWidth; panel.classList.add('is-changing');
      if (announce) root.querySelector('[data-globe-announcement]').textContent = name.textContent + ', ' + place.textContent;
    }
    function render() {
      if (!ready || !width || !height) return;
      project.rotate([-lon, -lat, 0]);
      ctx.clearRect(0, 0, width, height);
      const cx = width / 2, cy = height / 2;
      const ocean = ctx.createRadialGradient(cx-radius*.35,cy-radius*.4,radius*.1,cx,cy,radius);
      ocean.addColorStop(0,'#49515b'); ocean.addColorStop(.7,'#262b33'); ocean.addColorStop(1,'#101318');
      ctx.beginPath(); path({type:'Sphere'}); ctx.fillStyle=ocean; ctx.fill();
      ctx.beginPath(); path(grid); ctx.strokeStyle='rgba(255,255,255,.09)'; ctx.lineWidth=.5; ctx.stroke();
      for (const feature of world.features) {
        ctx.beginPath(); path(feature); ctx.fillStyle='#a2a9b0'; ctx.fill();
        ctx.strokeStyle='#525b65'; ctx.lineWidth=.45; ctx.stroke();
      }
      const shade=ctx.createRadialGradient(cx-radius*.45,cy-radius*.45,radius*.3,cx+radius*.2,cy+radius*.2,radius*1.25);
      shade.addColorStop(0,'rgba(255,255,255,.12)');shade.addColorStop(.65,'rgba(5,9,15,.05)');shade.addColorStop(1,'rgba(5,9,15,.65)');
      ctx.beginPath();path({type:'Sphere'});ctx.fillStyle=shade;ctx.fill();ctx.strokeStyle='rgba(255,255,255,.26)';ctx.lineWidth=.8;ctx.stroke();
      let best = -1, distance = .85;
      DEALERS.forEach((d,i) => { const dist=geo.geoDistance([lon,lat],[+d.lng,+d.lat]); if(dist<distance){distance=dist;best=i;} });
      if (explicit !== null && geo.geoDistance([lon,lat],[+DEALERS[explicit].lng,+DEALERS[explicit].lat])<1.4) best=explicit;
      updatePartner(best, false);
      DEALERS.forEach((d,i) => {
        if(geo.geoDistance([lon,lat],[+d.lng,+d.lat])>Math.PI/2-.03)return;
        const xy=project([+d.lng,+d.lat]);
        if(i===best){ctx.beginPath();ctx.arc(xy[0],xy[1],8,0,Math.PI*2);ctx.fillStyle='rgba(255,147,86,.22)';ctx.fill();}
        ctx.beginPath();ctx.arc(xy[0],xy[1],i===best?3.3:2,0,Math.PI*2);ctx.fillStyle=i===best?'#ff9b5d':'#f5f5f7';ctx.fill();
      });
      root.dataset.longitude = lon.toFixed(2);
    }
    function tick() {
      frame=0;if(!active||document.hidden)return;
      const gap=Math.abs(toLon-lon)+Math.abs(toLat-lat);
      if(reduce.matches || gap<.05){lon=toLon;lat=toLat;}else{lon+=(toLon-lon)*.13;lat+=(toLat-lat)*.13;}
      render();if(gap>.05&&!reduce.matches)frame=requestAnimationFrame(tick);
    }
    function wake(){if(!frame&&active&&ready&&!document.hidden)frame=requestAnimationFrame(tick);}
    function resize(){const r=canvas.getBoundingClientRect();width=r.width;height=r.height;const dpi=Math.min(devicePixelRatio||1,2);canvas.width=Math.round(width*dpi);canvas.height=Math.round(height*dpi);ctx.setTransform(dpi,0,0,dpi,0,0);radius=Math.max(10,Math.min(width,height)*.46);if(project)project.translate([width/2,height/2]).scale(radius);render();}
    function scroll(){
      if(!active||!ready||drag||reduce.matches)return;
      const r=root.getBoundingClientRect();
      if(lastTop !== null && Math.abs(r.top-lastTop)<1)return;
      const delta=lastTop===null?0:lastTop-r.top;
      lastTop=r.top;explicit=null;
      toLon+=delta*360/(innerHeight*.55+r.height);toLat=35;wake();
    }
    function choose(delta){
      if(!ready)return;
      const index=((selected<0?11:selected)+delta+DEALERS.length)%DEALERS.length;
      explicit=index;
      const target=+DEALERS[index].lng;
      toLon=lon+((target-lon+540)%360)-180;toLat=+DEALERS[index].lat;
      updatePartner(index,true);wake();
    }
    root.querySelector('[data-globe-prev]').addEventListener('click',()=>choose(-1));
    root.querySelector('[data-globe-next]').addEventListener('click',()=>choose(1));
    canvas.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();choose(e.key==='ArrowRight'?1:-1);}});
    canvas.addEventListener('pointerdown',e=>{if(!ready||e.button>0)return;explicit=null;drag={x:e.clientX,y:e.clientY,lon:lon,lat:lat};canvas.setPointerCapture(e.pointerId);});
    canvas.addEventListener('pointermove',e=>{if(!drag)return;toLon=drag.lon-(e.clientX-drag.x)*.55;toLat=Math.max(-65,Math.min(65,drag.lat+(e.clientY-drag.y)*.2));wake();});
    function release(){drag=null;lastTop=root.getBoundingClientRect().top;}
    canvas.addEventListener('pointerup',release);canvas.addEventListener('pointercancel',release);
    document.addEventListener('scroll',scroll,{passive:true,capture:true});
    const ro=new ResizeObserver(resize);ro.observe(canvas);
    reduce.addEventListener('change',()=>{toLon=lon;toLat=lat;wake();});
    document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else wake();});
    const observer=new IntersectionObserver(async entries=>{
      active=entries[0].isIntersecting;
      lastTop=root.getBoundingClientRect().top;
      if(!active){cancelAnimationFrame(frame);frame=0;return;}
      if(!ready&&!loading){
        loading=true;
        try{
          const values=await Promise.all([library(root.dataset.engine),fetch(root.dataset.world).then(r=>{if(!r.ok)throw Error('World asset unavailable');return r.json();})]);
          if(!root.isConnected)return;
          geo=values[0];world=values[1];project=geo.geoOrthographic().clipAngle(90).precision(.6);path=geo.geoPath(project,ctx);grid=geo.geoGraticule10();ready=true;
          root.classList.add('is-ready');resize();
          if(!reduce.matches)toLon=lon+12;
          wake();
        }catch(error){root.dataset.error='unavailable';name.textContent=empty;canvas.hidden=true;}
      }else wake();
    },{threshold:.05});observer.observe(root);
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){observer.disconnect();ro.disconnect();cancelAnimationFrame(frame);document.removeEventListener('scroll',scroll,true);}});
  }
  function boot(){document.querySelectorAll('[data-v3-globe]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
